import { Severity } from '@wix/ambassador-ecom-v1-checkout/types';
import { hasSubdivisionOrZipCodeShippingError, hasSubdivisionOrZipCodeTaxError } from './calculationError.utils';
import { getShippingMethods } from './getShippingMethods';
import { hasShippableItems } from './hasShippableItems';
export async function shouldNavigateToFastFlowCheckout(_ref) {
  var _checkoutSettings$ter, _checkout$payNowTotal, _checkout$violations, _getShippingMethods;
  let {
    checkout,
    prevTotalAmount,
    shouldUpdateShippingAddress,
    checkoutSettings,
    checkoutService,
    shouldSupportTimeSlotsInCheckout,
    needsShippingMethodSelection
  } = _ref;
  const getHasCustomField = async () => {
    var _checkoutSettings$che;
    const checkoutComposerEnabled = await checkoutService.isCheckoutComposerEnabled();
    if (checkoutComposerEnabled) {
      return !(await checkoutService.isExtendedFieldsFormEmpty());
    }
    return ((_checkoutSettings$che = checkoutSettings.checkoutCustomField) == null ? void 0 : _checkoutSettings$che.show) && checkoutSettings.checkoutCustomField.mandatory;
  };
  const hasTermsAndConditions = (_checkoutSettings$ter = checkoutSettings.termsAndConditions) == null ? void 0 : _checkoutSettings$ter.enabled;
  const hasCustomField = await getHasCustomField();
  const hasShippingError = hasSubdivisionOrZipCodeShippingError(checkout);
  const hasTaxError = hasSubdivisionOrZipCodeTaxError(checkout);
  const hasTotalAmountMismatchWithLatestSeen = prevTotalAmount !== ((_checkout$payNowTotal = checkout.payNowTotalAfterGiftCard) == null ? void 0 : _checkout$payNowTotal.amount);
  const hasViolations = (_checkout$violations = checkout.violations) == null ? void 0 : _checkout$violations.some(violation => violation.severity === Severity.ERROR || violation.severity === Severity.WARNING);
  const shouldChooseShippingMethod = shouldUpdateShippingAddress && hasShippableItems(checkout) && needsShippingMethodSelection && ((_getShippingMethods = getShippingMethods(checkout, {}, shouldSupportTimeSlotsInCheckout)) == null ? void 0 : _getShippingMethods.length) !== 1;
  return shouldChooseShippingMethod || hasTermsAndConditions || hasCustomField || hasShippingError || hasTaxError || hasTotalAmountMismatchWithLatestSeen || hasViolations;
}
//# sourceMappingURL=shouldNavigateToFastFlow.js.map